<template>
  <div v-html="title" v-show="!isLoading"></div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PageTitle',
  props: {
    fixedTitle: {
      type: String,
      required: false,
      default: null,
    },
    tag: {
      type: String,
      required: false,
      default: 'h1',
    }
  },
  computed: {
    title() {
      const title = this.fixedTitle ? this.fixedTitle : this.$store.state.pageTitle;
      return `<${this.tag}>${title}</${this.tag}>`;
    },
    ...mapGetters({ isLoading: 'getIsLoading' }),
  }
};
</script>
